import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import _ from 'lodash';

const initialState = {
  sidebar: {
    loading: {
      organization: false,
      roles: false,
      users: false,
      permissions: false
    },
    list: {
      organizationList: null,
      roleList: null,
      userList: null,
      permissionList: null
    }
  },
  viewer: {
    organization: {
      organizationDetails: null
    }
  }
}

export const fetchOrganizationDetails = createAsyncThunk(
  'fetchOrganizationDetails',
  async (organizationId, thunkAPI) => {
    return new Promise((resolve, reject) => {
      axios.post('/iam/getOrganizationDetails', { organizationId: organizationId }, {
        headers: { 'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('insuranceUser')).token }
      })
        .then((response) => {
          if (response.data.length === 0) resolve(null)
            console.log('res', response.data);

          const uniqueGroups = _.groupBy(response.data, 'organizationId')
          const listData = Object.keys(uniqueGroups).map(r => {
            const key = r
            const label = uniqueGroups[r][0]['organizationName']
            return {key, label}
          })

          resolve({listData: listData, organizationViewData: response.data})
        })
        .catch((err) => {
          console.log('error', err);
          reject(null)
        })  
    })
  }
);

export const iamSlice = createSlice({
  name: "iam",
  initialState: initialState,
  reducers: {
    addUser(state, action) {
      state.user = action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      // organization details
      .addCase(fetchOrganizationDetails.pending, (state) => {
        state.sidebar.loading.organization = true;
      })
      .addCase(fetchOrganizationDetails.fulfilled, (state, action) => {
        state.sidebar.list.organizationList = action.payload.listData
        state.viewer.organization.organizationDetails = action.payload.organizationViewData
        state.sidebar.loading.organization = false
      })
      .addCase(fetchOrganizationDetails.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
        state.sidebar.loading.organization = false
      });
  },
})